export const KpiRing = ({ label, data, color, testId, delay = 0, unit }) => {
  const r = 34, c = 2 * Math.PI * r;
  const p = data?.persen || 0;
  return (
    <div className="rise rounded-md border border-border bg-[#131B29] p-5 transition-colors hover:border-sky-500/40" style={{ animationDelay: `${delay}ms` }} data-testid={testId}>
      <p className="font-mono text-[10px] uppercase tracking-widest text-slate-400">{label}</p>
      <div className="mt-4 flex items-center gap-4 xl:gap-2 2xl:gap-3">
        {/* Enam kartu satu baris hanya menyisakan ~104px isi di 1280px (sidebar 256 + p-10 + 5 gap),
            sementara ring 84px + angka 4xl butuh ~230px. Yang mengalah isi kartunya: ring dan angka
            sama-sama mengecil di xl lalu naik lagi di 2xl (1536px, ~147px isi). viewBox tetap, jadi
            lingkarannya cuma di-skala — tidak ada geometri SVG yang dihitung ulang.
            Ring 44px + angka 42px = ~94px, jadi barisnya masih muat di 104px. */}
        <svg width="84" height="84" viewBox="0 0 84 84" className="-rotate-90 shrink-0 xl:h-11 xl:w-11 2xl:h-14 2xl:w-14">
          <circle cx="42" cy="42" r={r} stroke="#1C273B" strokeWidth="8" fill="none" />
          <circle cx="42" cy="42" r={r} stroke={color} strokeWidth="8" fill="none" strokeLinecap="round"
            strokeDasharray={c} strokeDashoffset={c - (c * p) / 100} style={{ transition: "stroke-dashoffset 1s ease" }} />
        </svg>
        {/* `whitespace-nowrap`: "83.33%" terlipat jadi dua baris terbaca seperti rusak. */}
        <p className="whitespace-nowrap font-display text-4xl font-extrabold leading-none xl:text-base 2xl:text-xl" style={{ color }} data-testid={`${testId}-value`}>{p}%</p>
      </div>
      {/* Sub-baris di LUAR baris ring supaya dapat lebar penuh kartu. Di dalam, sisa setelah ring
          cuma ~52px (1280) / ~79px (1536) sementara "12/12 misi selesai" butuh ~92-110px — selalu
          terlipat dua baris. Di luar: ~104px / ~147px, jadi muat satu baris. */}
      <p className="mt-2 text-xs text-slate-400 xl:text-[10px] 2xl:text-xs">{data?.selesai ?? 0}/{data?.total ?? 0} {unit} selesai</p>
      {/* `proses: null` = komponen tanpa status proses (CP); `0` tetap ditampilkan. */}
      {data?.proses != null && <p className="text-xs text-amber-400/80 xl:text-[10px] 2xl:text-xs">{data.proses} dalam proses</p>}
    </div>
  );
};
